import muiStyled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import {bool, string} from 'prop-types';

import {connectorShape} from '../../../../proptypes-shapes';

const ConnectorImage = muiStyled('img')({
  height: 20
});

const Name = muiStyled(Typography)(() => ({
  fontSize: 18
}));

const ProjectTitle = ({isFolderGrouping, connector, cardTitle, isListViewType}) => {
  if (isFolderGrouping && connector) {
    return <ConnectorImage alt="logo connecteur" src={connector.url_logo} />;
  }

  return (
    <Name component="div" variant="h5" sx={{lineHeight: isListViewType ? 1 : 1.1}}>
      {cardTitle}
    </Name>
  );
};

ProjectTitle.propTypes = {
  isFolderGrouping: bool.isRequired,
  connector: connectorShape.isRequired,
  cardTitle: string.isRequired,
  isListViewType: bool.isRequired
};

export default ProjectTitle;
